import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Dropzone, FileItem } from "@dropzone-ui/react";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: "none",
  },
});

function MMS(props) {
  const { classes, upload, files, onFileDelete } = props;
  return (
    <>
      <Grid container>
        <Grid item xs={2}>
          <h1>MMS</h1>
        </Grid>
      </Grid>
      <Typography variant="body1" gutterBottom>
        Click the button to upload an image. The Image will be included with the
        script when sending.
      </Typography>
      <Grid container alignItems="center">
        <Grid item xs={8}>
          <Dropzone
            onChange={upload}
            maxFiles={1}
            maxFileSize={2097152}
            accept="image/png,image/jpeg,video/mp4"
            value={files}
          >
            {files.map((file) => (
              <FileItem {...file} onDelete={onFileDelete} preview />
            ))}
          </Dropzone>
          {/* <input
            accept="image/jpeg,image/png"
            className={classes.input}
            id="contained-button-file"
            type="file"
            onChange={upload}
          />
          <label htmlFor="contained-button-file">
            <Button
              variant="contained"
              color="primary"
              component="span"
              className={classes.button}
            >
              Upload
            </Button>
          </label> */}
        </Grid>
        {/* <Grid item xs={4}>
          <Typography variant="subheading" gutterBottom>
            {fileName}
          </Typography>
        </Grid>
        <Grid item xs={8}></Grid> */}
      </Grid>
    </>
  );
}

export default withStyles(styles)(MMS);
